import { __decorate } from "tslib";
import Component from "vue-class-component";
import StringUtils from "@/utils/stringUtils";
import ReactiveComponent from "../components/ReactiveComponent";
import Task from "@/services/task";
import { Emit, Prop, PropSync } from "vue-property-decorator";
import ProgressButton from "@/components/ProgressButton.vue";
let VideoForm = class VideoForm extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.nameInvalid = false;
        this.locationInvalid = false;
        this.dateInvalid = false;
        this.boardsInvalid = false;
        this.linkInvalid = false;
        this.allBoards = [];
        this.boardsTask = Task.idle();
    }
    created() {
        this.subscribeQuery({
            tag: "boards",
            options: {
                query: require("@/apollo/queries/allBoards.graphql")
            },
            onTask: task => {
                this.boardsTask = task;
                if (task.isSuccessful) {
                    this.allBoards = task.data.board;
                }
            }
        });
    }
    emitSubmit() { }
    handleSubmit() {
        if (this.task.isLoading) {
            return;
        }
        this.nameInvalid = StringUtils.isBlank(this.nameValue);
        this.locationInvalid = StringUtils.isBlank(this.locationValue);
        this.dateInvalid = this.dateValue == null;
        this.boardsInvalid = this.boardsValue.length == 0;
        this.linkInvalid =
            StringUtils.isNotBlank(this.linkValue) &&
                !this.linkValue.startsWith("http://") &&
                !this.linkValue.startsWith("https://");
        if (this.nameInvalid ||
            this.locationInvalid ||
            this.dateInvalid ||
            this.boardsInvalid ||
            this.linkInvalid) {
            return;
        }
        this.emitSubmit();
    }
};
__decorate([
    Prop()
], VideoForm.prototype, "task", void 0);
__decorate([
    PropSync("name", { type: String, default: "" })
], VideoForm.prototype, "nameValue", void 0);
__decorate([
    PropSync("location", { type: String, default: "" })
], VideoForm.prototype, "locationValue", void 0);
__decorate([
    PropSync("link", { type: String, default: "" })
], VideoForm.prototype, "linkValue", void 0);
__decorate([
    PropSync("date")
], VideoForm.prototype, "dateValue", void 0);
__decorate([
    PropSync("boards", { type: Array, default: [] })
], VideoForm.prototype, "boardsValue", void 0);
__decorate([
    Emit("submit")
], VideoForm.prototype, "emitSubmit", null);
VideoForm = __decorate([
    Component({
        components: { ProgressButton }
    })
], VideoForm);
export default VideoForm;
